<template>
  <div class="menu-item">
    <div v-for="item in data.children" :key="`${path}/${item.path}`">
      <el-submenu v-if="item.children" :index="`${path}/${item.path}`">
        <template slot="title">
          <span>{{ item.meta.label }}</span>
        </template>
        <menu-item :data="item" :path="`${path}/${item.path}`"></menu-item>
      </el-submenu>
      <el-menu-item v-else :index="`${path}/${item.path}`">
        <template slot="title">
          <span>{{ item.meta.label }}</span>
        </template>
      </el-menu-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'menu-item',
  components: {},
  props: {
    data: Object,
    path: String,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="less" scoped></style>
